import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrnTooltipImports } from '@spartan-ng/brain/tooltip';
import { BadgeVariants, HlmBadgeDirective } from '@spartan-ng/ui-badge-helm';
import { HlmTooltipImports } from '@spartan-ng/ui-tooltip-helm';

type ImpactInfo = {
    title: string;
    description: string;
    variant: BadgeVariants['variant'];
    indicatorClass: string;
}

const impactMap: Record<string, ImpactInfo> = {
    minor: {
        title: 'REPORTS.COMPONENT.IMPACT_BADGE.MINOR.TITLE',
        description: 'REPORTS.COMPONENT.IMPACT_BADGE.MINOR.DESCRIPTION',
        variant: 'outline',
        indicatorClass: 'tw-bg-grey-500'
    },
    moderate: {
        title: 'REPORTS.COMPONENT.IMPACT_BADGE.MODERATE.TITLE',
        description: 'REPORTS.COMPONENT.IMPACT_BADGE.MODERATE.DESCRIPTION',
        variant: 'amber',
        indicatorClass: 'tw-bg-amber-500'
    },
    serious: {
        title: 'REPORTS.COMPONENT.IMPACT_BADGE.SERIOUS.TITLE',
        description: 'REPORTS.COMPONENT.IMPACT_BADGE.SERIOUS.DESCRIPTION',
        variant: 'orange',
        indicatorClass: 'tw-bg-orange-500'
    },
    critical: {
        title: 'REPORTS.COMPONENT.IMPACT_BADGE.CRITICAL.TITLE',
        description: 'REPORTS.COMPONENT.IMPACT_BADGE.CRITICAL.DESCRIPTION',
        variant: 'red',
        indicatorClass: 'tw-bg-red-500'
    }
};

@Component({
    selector: 'sona-impact-cell',
    standalone: true,
    template: `
        @if(_impactInfo(); as impactInfo) {
            <hlm-tooltip>
                <span hlmBadge hlmTooltipTrigger [variant]="impactInfo.variant" size="lg" class="tw-cursor-help">
                    <div class="tw-rounded-full tw-w-2 tw-h-2 tw-mr-2 {{ impactInfo.indicatorClass }}"></div>
                    {{ impactInfo.title | translate }}
                </span>
                <ng-container *brnTooltipContent>
                    <div *brnTooltipContent class="tw-max-w-80">
                        <div class="tw-text-muted-foreground">{{ impactInfo.description | translate }}</div>
                    </div>
                </ng-container>
            </hlm-tooltip>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        HlmBadgeDirective,
        HlmTooltipImports,
        BrnTooltipImports,
        TranslatePipe
    ],
    host: {
        class: 'tw-block'
    }
})
export class SonaImpactCellComponent {
    readonly impact = input.required<string | null>();
    protected readonly _impactInfo = computed(() => {
        const impact = this.impact();
        return impact ? impactMap[impact] : null;
    });
}
